/**
 * @desc 根据平台订单id获取订单信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getBySpOrderId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getBySpOrderId`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
